








































































import {
  SaveProjectPropertyKeyCommand,
  saveProjectPropertyKey,
  getProjectPropertyKey
} from "@/api/project/project-properties-api";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DEFAULT_KEY_NAME from "@/constant/property";
import { cloneDeep } from "lodash";

@Component({})
export default class ProjectPropertyKeyEditPage extends Vue {
  DEFAULT_KEY_NAME = DEFAULT_KEY_NAME;
  @Prop({ required: true }) id!: string;

  @Watch("id", { immediate: true })
  onIdChanged(id: string) {
    this.initKey(id);
  }

  command: SaveProjectPropertyKeyCommand | null = null;
  data: SaveProjectPropertyKeyCommand | null = null;
  error: string = "";

  async submit() {
    if (!this.command) {
      return;
    }

    try {
      await saveProjectPropertyKey(this.command);
      this.$router.push({ name: "project-property-keys" });
    } catch (error) {
      this.error = error[0];
    }
  }

  clickSubmitButton() {
    (this.$refs["btnSubmit"] as any).click();
  }

  async initKey(id: string) {
    this.command = await getProjectPropertyKey(id);

    if (this.command) {
      this.data = cloneDeep(this.command);
    }
  }

  get isDefaultName(): boolean {
    if (this.data) {
      return this.data.name === DEFAULT_KEY_NAME;
    }

    return false;
  }
}
